import React, { useState } from "react";
import { RiCloseFill, RiDeleteBinLine } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import UploadButton from "../../Input/UploadButton";

function ProcedureEdits({patientInfo}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // labDetails will hold an object with keys as lab request index.
  // Each entry stores: expanded (boolean), labFinding (string), and documentArray (array).
  const [labDetails, setLabDetails] = useState({});
  // const { patientInfo } = usePatient();
  const navigate = useNavigate();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const close = () => {
    setIsModalOpen(false);
    navigate('/procedures');
  };

  // Toggles the expanded state for a given lab request index.
  const toggleExpand = (index) => {
    setLabDetails(prev => {
      const current = prev[index] || { expanded: false, labFinding: '', documentArray: [] };
      return {
        ...prev,
        [index]: {
          ...current,
          expanded: !current.expanded
        }
      };
    });
  };

  // Updates the lab findings for a given lab request.
  const handleLabFindingChange = (index, value) => {
    setLabDetails(prev => ({
      ...prev,
      [index]: {
        ...prev[index],
        labFinding: value
      }
    }));
  };

  // Updates the document array for a given lab request.
  const updateDocuments = (index, docs) => {
    setLabDetails(prev => ({
      ...prev,
      [index]: {
        ...prev[index],
        documentArray: docs
      }
    }));
  };

  // Deletes a document from the document array for a specific lab request.
  const deleteDoc = (index, docName) => {
    setLabDetails(prev => ({
      ...prev,
      [index]: {
        ...prev[index],
        documentArray: prev[index].documentArray.filter(doc => doc.name !== docName)
      }
    }));
  };

  return (
    <div className="w-100 m-t-40">
      <div className="m-t-20">
        <h2>Lab Work For {`${patientInfo?.firstName} ${patientInfo?.lastName}`}</h2>
        <div className="tabs m-t-10 bold-text"></div>
        <div className="flex space-between m-l-40 p-20">
          <div className="flex flex-direction-v col-4">
            <TagInputs label="Patient's Name" value={`${patientInfo?.firstName} ${patientInfo?.lastName}`} readOnly />
            <TagInputs label='Clinic' value={patientInfo?.hospitalName} readOnly />
            <TagInputs label="Doctor's Name" value={patientInfo?.doctor} readOnly />
            {/* <TagInputs label='Severity' value={patientInfo?.severity} readOnly /> */}
            <TagInputs label='Date Initiated' value={patientInfo?.dateCreated} readOnly />
            <TagInputs label='Time Initiated' value={patientInfo?.timeInitiated} readOnly />
          </div>
          <div className="flex flex-direction-v col-8">
            <TagInputs label="Doctor's Diagnosis" type='textArea' value={patientInfo?.diagnosis} readOnly multiline />
            <TagInputs label='Additional Notes' type='textArea' value={patientInfo?.notes} readOnly multiline />
          </div>
        </div>

        <div className="tabs bold-text"></div>
        <h3>Lab work to be processed</h3>
        <div className="m-l-40 p-20">
          {patientInfo?.labWorkRequested.map((labRequest, index) => (
            <div key={index} className="lab-request-item m-t-10">
              <div
                className="lab-request-header flex space-between pointer"
                onClick={() => toggleExpand(index)}
              >
                <span>{labRequest}</span>
                <span>{labDetails[index]?.expanded ? "Collapse" : "Expand"}</span>
              </div>
              {labDetails[index]?.expanded && (
                <div className="lab-request-details m-t-10">
                  <TagInputs
                    label='Lab Findings'
                    type='textArea'
                    value={labDetails[index]?.labFinding || ''}
                    onChange={(e) => handleLabFindingChange(index, e.target.value)}
                    multiline
                  />
                  <div className="m-t-20 m-b-20">
                    <UploadButton
                      // Adjust these props if needed for your UploadButton component
                      setDocNames={() => {}}
                      setdocumentArray={(docs) => updateDocuments(index, docs)}
                    />
                  </div>
                  {labDetails[index]?.documentArray?.map((doc, idx) => (
                    <div key={idx} className="m-t-10 flex">
                      <a href={doc.path} target="_blank" className="m-r-10">
                        {doc.name}
                      </a>
                      <RiDeleteBinLine
                        color="red"
                        className="pointer"
                        onClick={() => deleteDoc(index, doc.name)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        <button onClick={openModal} className="submit-btn m-t-20">Submit</button>
      </div>
      {isModalOpen &&
        <SuccessModal Name={`${patientInfo?.firstName} ${patientInfo?.lastName}`} closeModal={close} />
      }
    </div>
  );
}

export default ProcedureEdits;
